export const filetype = (filename: string): string | null => {
  if (typeof filename !== "string") return null;
  const ext = filename.match(/\.[0-9a-z]+$/i);
  return ext && ext[0];
};
